(function(angular, _, moment) {
    'use strict';

    /**
     * Webtrekk specific Date format methods
     */
    angular.module('wtApp.wtCommon').service('wtDate', wtDate);

    wtDate.$inject = ['wtNumber'];

    /* eslint no-unused-vars:0 */
    function wtDate(wtNumber) {
        // If no language is provided the default language settings should be used
        var defaultLanguage = 'en';

        /**
         * Will simply return the language set in this service
         * @returns {string}
         */
        function getLanguage() {
            return defaultLanguage;
        }

        /**
         * Should update the degault language inside this service
         * @param {string} newLanguage
         */
        function setLanguage(newLanguage) {
            if (!_.isUndefined(newLanguage) && !_.isEmpty(newLanguage)) {
                defaultLanguage = newLanguage;
            }
        }

        /**
         * Converts a date string to type Date
         * @param {string} dateString
         * @returns {Date}
         */
        function parseDate(dateString) {
            var date;
            var newDateString;
            newDateString = dateString.replace(/-/g, '/');
            date = new Date(newDateString);
            return date;
        }

        /**
         * Should return different time formats for each language. Default is English.
         * TODO: Will these settings be customizable from the user's configuration???
         * @param {string} iLang
         * @returns {*}
         */
        function getDefaultTimeFormats(iLang) {
            var lang = iLang || getLanguage();
            var defaultTimeFormats = {
                en: {
                    weekday: '',
                    hour: '%H:%i:%s',
                    week_en: '%v/%x',
                    month: '%Y/%m',
                    week: '%v/%x',
                    second: '%Y-%m-%d %H:%i:%s', // TODO: not used yet but seems wrong
                    quarter: '',
                    //                  'day': '%d.%m.%Y',
                    day: '%Y-%m-%d',
                    year: '%Y',
                    day_hour: '%H %Y-%m-%d' // TODO: not used yet but seems wrong
                },
                de: {
                    weekday: '',
                    hour: '%H:%i:%s',
                    week_en: '%v/%x',
                    month: '%Y/%m',
                    week: '%v/%x',
                    second: '%d.%m.%Y %H:%i:%s',
                    quarter: '',
                    day: '%d.%m.%Y',
                    year: '%Y',
                    day_hour: '%H %d.%m.%Y' // TODO: not used yet but seems wrong
                },
                zh: {
                    weekday: '',
                    hour: '%H:%i:%s',
                    week_en: '%v/%x',
                    month: '%Y/%m',
                    week: '%v/%x',
                    second: '%Y-%m-%d %H:%i:%s', // TODO: not used yet but seems wrong
                    quarter: '',
                    //                  'day': '%d.%m.%Y',
                    day: '%Y-%m-%d',
                    year: '%Y',
                    day_hour: '%H %Y-%m-%d' // TODO: not used yet but seems wrong
                }
            };
            // should return the settings for the given language or if not found for the default language
            return defaultTimeFormats[lang] || defaultTimeFormats[getLanguage()];
        }

        function getDatePickerFormats(iLang) {
            var lang = iLang || getLanguage();
            return {
                en: {
                    full: 'YYYY-MM-DD HH:mm',
                    date: 'YYYY-MM-DD',
                    server: 'YYYY-MM-DDTHH:mm:ss'
                },
                de: {
                    full: 'DD.MM.YYYY HH:mm',
                    date: 'DD.MM.YYYY',
                    server: 'YYYY-MM-DDTHH:mm:ss'
                },
                zh: {
                    full: 'YYYY-MM-DD HH:mm',
                    date: 'YYYY-MM-DD',
                    server: 'YYYY-MM-DDTHH:mm:ss'
                }
            }[lang] || {};
        }

        return {
            getDefaultTimeFormats: getDefaultTimeFormats,
            getDatePickerFormats: getDatePickerFormats,
            getLanguage: getLanguage,
            setLanguage: setLanguage,

            /**
             * Converts a datestring with format 'YYYYMMDD' (20131211) to a valid UTC timestamp
             * @param {string} dateString
             * @returns {number}
             */
            utcDate: function(dateString) {
                /* eslint id-length:0 */
                var d;
                var m;
                var y;
                y = parseInt(dateString.slice(0, 4));
                m = parseInt(dateString.slice(4, 6)) - 1;
                d = parseInt(dateString.slice(6));
                return Date.UTC(y, m, d);
            },

            /**
             * Converts a datestring with format 'YYYYMMDD' (20131211) to a valid UNIX timestamp
             * @param {string} dateString
             * @returns {number}
             */
            getTimestampOfDateStr: function(dateString) {
                var y = parseInt(dateString.slice(0, 4));
                var m = parseInt(dateString.slice(4, 6)) - 1;
                var d = parseInt(dateString.slice(6));
                return Date.UTC(y, m, d);
            },

            /**
             * Converts a datestring with format 'YYYYMMDD' (20131211) to a UNIX timestamp without converting it into UTC
             * so it uses 0:00 o'clock without adding the timezone (like in function getTimestampOfDateStr)
             * @param {string} dateString
             * @returns {number}
             */
            getTimestampOfDateStrWithoutTimezoneOffset: function(dateString) {
                var y = parseInt(dateString.slice(0, 4));
                var m = parseInt(dateString.slice(4, 6)) - 1;
                var d = parseInt(dateString.slice(6));
                return new Date(y, m, d, 0, 0, 0).getTime();
            },

            isSunday: function(ms) {
                return moment(ms).day() === 0;
            },

            /**
             * Returns the date of easter SUNDAY for a given year
             * @param {number} iYear
             * @param {number} iDifference
             * @returns {*}
             */
            getEasterDate: function(iYear, iDifference) {
                var year = iYear;
                if ((year === '') || (year === null)) {
                    year = new Date().getYear();
                }
                // check valid timespan
                if ((year < 1970) || (year > 2099)) {
                    return 'cannot calculate eastern for this year :(';
                }
                // some wild calculation stuff found in the www
                var a = year % 19;
                var d = (19 * a + 24) % 30;
                var day = d + (2 * (year % 4) + 4 * (year % 7) + 6 * d + 5) % 7;
                if ((day === 35) || ((day === 34) && (d === 28) && (a > 10))) {
                    day -= 7;
                }
                return new Date(year, 2, 22 + day);
            },

            /**
             * Formats a date (for chart's x-axis...)
             * Got rid of Highcharts dependency, use moment plugin instead see http://momentjs.com/ for usage
             * @param {string} date A date
             * @returns {string} Formatted date
             */
            formatDate: function(date) {
                var format = getDatePickerFormats(this.lang || getLanguage());
                return moment(date).format(format);
            },

            /**
             * Gets a date that is numOfDays days after dateString
             * @param {string} iDateString
             * @param {number} iNumOfDays
             * @param {string} iLang
             * @returns {*}
             */
            getDateAfterDaysString: function(iDateString, iNumOfDays, iLang) {
                var lang = iLang || getLanguage();
                var format = getDatePickerFormats(lang).date;
                return moment(iDateString).add(iNumOfDays, 'days').format(format);
            },

            /**
             * Gets last day of month
             * @param {Date} iDate
             * @returns {*}
             */
            getLastDayOfMonth: function(iDate) {
                var date = iDate || new Date();
                return moment(date).daysInMonth();
            },

            /**
             * Returns date formatting strings to be passed to moment.js
             * @param {string} iLang
             * @returns {Object}
             */
            momentFormats: function(iLang) {
                var lang = iLang || getLanguage();

                return {
                    en: {
                        second: 'YYYY-MM-DD HH:mm:ss',
                        day: 'YYYY-MM-DD',
                        day_hour: 'HH YYYY-MM-DD'
                    },
                    de: {
                        second: 'DD.MM.YYYY HH:mm',
                        day: 'DD.MM.YYYY',
                        day_hour: 'HH DD.MM.YYYY'
                    },
                    zh: {
                        second: 'YYYY-MM-DD HH:mm:ss',
                        day: 'YYYY-MM-DD',
                        day_hour: 'HH YYYY-MM-DD'
                    }
                }[lang] || {};
            },

            /**
             * Calculates the unformatted date, readable by backend service (Reverse of getFormattedDate)
             * @param {*} iValue
             * @param {*} iFormat
             * @param {string} iLanguage
             * @returns {string}
             */
            getUnformattedDate: function(iValue, iFormat, iLanguage) {
                var language = iLanguage || getLanguage();
                var value = iValue;
                var format = iFormat;
                var returnValue = value;
                var momentFormat;

                switch (format) {
                    case 'second':
                        momentFormat = this.momentFormats(language)[format];
                        returnValue = moment(value, momentFormat).format('YYYYMMDDHHMMSS');
                        break;
                    case 'day_hour':
                        momentFormat = this.momentFormats(language)[format];
                        returnValue = moment(value, momentFormat).format('YYYYMMDDHH');
                        break;
                    case 'day':
                        momentFormat = this.momentFormats(language)[format];
                        returnValue = moment(value, momentFormat).format('YYYYMMDD');
                        break;
                    case 'week':
                    case 'week_en':
                    case 'month':
                        returnValue = value.split('/').join('');
                        break;
                    // un-formatted:
                    case 'hour':
                    case 'weekday':
                    case 'quarter':
                    case 'high_time': // yay, that's minutes!
                    case 'year':
                        break;
                    default:
                        break;
                }
                return returnValue;
            },

            /**
             * Simple date formatter method
             * @param {*} iValue The value to be transformed
             * @param {string} iFormat The format (i.e. second, hour etc)
             * @param {Object}  iUserDefinedTimeFormats Optional obj of format styles (i.e. {day: %d.%m.%Y})
             * @param {string} iLanguage
             * @returns {string}
             */
            getFormattedDate: function(iValue, iFormat, iUserDefinedTimeFormats, iLanguage) {
                var value = iValue;
                var format = iFormat;
                var userDefinedTimeFormats = iUserDefinedTimeFormats;
                var language = iLanguage;
                var week;
                var month;
                var day;
                var hour;
                var minute;
                var second;

                if (!value || !_.isString(value)) {
                    return '';
                }
                var timeFormats = userDefinedTimeFormats || getDefaultTimeFormats(language);
                var year = value.substr(0, 4);
                // If an unknown date format is given (i.e. *_hyphen) make sure to return the raw value at and not undefined
                var formattedValue = timeFormats[format] || value;

                if (format === 'second') {
                    month = value.substr(4, 2);
                    day = value.substr(6, 2);
                    hour = value.substr(8, 2);
                    minute = value.substr(10, 2);
                    second = value.substr(12, 2);
                    formattedValue = formattedValue.replace(/\%Y/g, year);
                    formattedValue = formattedValue.replace(/\%m/g, month);
                    formattedValue = formattedValue.replace(/\%d/g, day);
                    formattedValue = formattedValue.replace(/\%H/g, hour);
                    formattedValue = formattedValue.replace(/\%i/g, minute);
                    formattedValue = formattedValue.replace(/\%s/g, second);
                }
                if (format === 'hour') {
                    formattedValue = value;
                    //                      formattedValue = moment(parseInt(value * 1000 * 60 * 60)).format('HH:mm');
                }
                if (format === 'day_hour') {
                    month = value.substr(4, 2);
                    day = value.substr(6, 2);
                    hour = value.substr(8, 2);
                    formattedValue = formattedValue.replace(/\%Y/g, year);
                    formattedValue = formattedValue.replace(/\%m/g, month);
                    formattedValue = formattedValue.replace(/\%d/g, day);
                    formattedValue = formattedValue.replace(/\%H/g, hour);
                }
                if (format === 'day') {
                    month = value.substr(4, 2);
                    day = value.substr(6, 2);
                    // FormattedValue = moment([year, month, day]).format(outputFormat);
                    month = value.substr(4, 2);
                    day = value.substr(6, 2);
                    formattedValue = formattedValue.replace(/\%Y/g, year);
                    formattedValue = formattedValue.replace(/\%m/g, month);
                    formattedValue = formattedValue.replace(/\%d/g, day);
                }
                if (format === 'weekday') {
                    formattedValue = value;
                }
                if (format === 'week') {
                    week = value.substr(4, 2);
                    formattedValue = formattedValue.replace(/\%v/g, year);
                    formattedValue = formattedValue.replace(/\%x/g, week);
                }
                if (format === 'week_en') {
                    week = value.substr(4, 2);
                    formattedValue = formattedValue.replace(/\%v/g, year);
                    formattedValue = formattedValue.replace(/\%x/g, week);
                }
                if (format === 'month') {
                    month = value.substr(4, 2);
                    formattedValue = formattedValue.replace(/\%Y/g, year);
                    formattedValue = formattedValue.replace(/\%m/g, month);
                }
                if (format === 'quarter') {
                    formattedValue = value;
                }
                if (format === 'high_time') {
                    formattedValue = value;
                }
                if (format === 'year') {
                    formattedValue = formattedValue.replace(/\%Y/g, year);
                }
                if (format === 'seconds_to_time') {
                    var sign = parseInt(value) < 0 ? '-' : '';
                    var secNum = parseInt(Math.abs(value));
                    var hours = Math.floor(secNum / 3600);
                    var minutes = Math.floor((secNum - (hours * 3600)) / 60);
                    var seconds = secNum - (hours * 3600) - (minutes * 60);
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes;
                    }
                    if (seconds < 10) {
                        seconds = '0' + seconds;
                    }
                    formattedValue = sign + hours + ':' + minutes + ':' + seconds;
                }

                return formattedValue;
            }
        };
    }
})(window.angular, window._, window.moment);
